import { use } from 'echarts/core'
import {
  LineChart
} from 'echarts/charts'
import ECharts, { THEME_KEY } from 'vue-echarts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import {
  CanvasRenderer
} from 'echarts/renderers'
import chartjsMixin from '@/agilis/components/Chart/Chartjs/mixin/chartjsMixin'

use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  LineChart,
  GridComponent,
  CanvasRenderer
])
export default {
  name: 'EchartsLine',
  mixins: [chartjsMixin],
  components: {
    'v-chart': ECharts
  },
  props: {
    items: {
      type: [Object, Array]
    }
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  computed: {
    chartData () {
      if (this.items) {
        let chart = this.dashboardMetric.option
        const columns = Object.values(this.dashboardMetric.detail.dataTable.columns)
        const labelColConfig = columns[0]
        const valueColConfig = columns[1]
        const items = this.items
        chart.series[0].data = []
        items.forEach(item => {
          chart.series[0].data.push(this.renderColumn(valueColConfig, item))
          chart.xAxis.data.push(this.renderColumn(labelColConfig, item))
        })
        return chart
      }
    }
  }
}
